import { Box, Typography, useTheme } from '@mui/material';
import Link from 'next/link';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import AirPlaneIcon from '@/components/shared/icons/airplane-out-icon';
import HomeIcon from '@/components/shared/icons/home-icon';
import { Rutas } from '@/constants/rutas';
import { translate } from '@/data/fixture-transalations';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { getDate_dd_MM } from '@/helpers/datetime-helper';
import { getCssClass } from '@/helpers/fixtures-helper';
import { getTeamImageById } from '@/helpers/images-helper';
import { getCompetitionImage } from '@/helpers/leagues-helper';
import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const GetFixtureBox = ({ fixtures, id, isLastFixtures }) => {
    const theme = useTheme();
    if (fixtures?.length > 0) {
        return fixtures.map((fixture, index) => {
            const cssClass = getCssClass(fixture);

            const rival = fixture?.home?.id === id ? fixture?.away : fixture?.home;
            const icon = fixture?.home?.id === id ? <HomeIcon width={15} /> : <AirPlaneIcon width={15} />;

            return (
                <Link
                    key={index}
                    className="last-fixtures__box"
                    style={{
                        width: `${100 / fixtures.length}%`,
                        cursor: 'pointer',
                        borderRight:
                            index !== fixtures?.length - 1
                                ? `1px solid ${theme.palette.border.main}`
                                : 'none',
                    }}
                    href={`${Rutas.PARTIDO}/${fixture.fixtureId ?? fixture?.id}/alineaciones-probables`}
                    prefetch={false}
                >
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'} gap="4px">
                        {icon}
                        <Typography style={{ fontSize: '13px' }}>{getDate_dd_MM(fixture?.date)}</Typography>
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginLeft: '8px',
                            paddingLeft: '6px',
                            paddingRight: '6px',
                        }}
                        variant="div"
                    >
                        <CustomTeamImageWithDefault
                            key={index}
                            teamId={rival.id}
                            width={25}
                            height={25}
                            alt={rival.name}
                        ></CustomTeamImageWithDefault>
                        {isLastFixtures && (
                            <Box
                                className={cssClass}
                                style={{ display: 'flex', padding: '0 4px', borderRadius: '4px' }}
                            >
                                <span style={{ fontSize: '12px' }}>{fixture?.home?.goals}</span>
                                <span style={{ fontSize: '12px' }}>-</span>
                                <span style={{ fontSize: '12px' }}>{fixture?.away?.goals}</span>
                            </Box>
                        )}
                    </Box>
                    <Box style={{ display: 'flex', marginTop: '4px', alignItems: 'center' }}>
                        <CustomImageComponent
                            src={getCompetitionImage(fixture?.leagueId, 15)}
                            width={15}
                            height={15}
                            alt="competición"
                            title="competición"
                            style={{ marginRight: '4px' }}
                        />
                        <Typography style={{ fontSize: '14px' }}>{translate(fixture.round, true)}</Typography>
                    </Box>
                </Link>
            );
        });
    }
};

const FixturesPreview = ({
    fixtures,
    isLastFixtures,
    title,
    id,
    setTabIndex,
    mostrarVerMas = true,
    urlVerMas = null,
}) => {
    const theme = useTheme();
    return (
        <CustomSectionWrapper color="accent2" mb={2}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: 1,
                    borderColor: theme.palette.divider,
                    pb: 1,
                    mb: 1,
                }}
            >
                <Typography fontSize={14} fontWeight={500}>
                    {title}
                </Typography>
                {mostrarVerMas && (
                    <Typography
                        color="primary.main"
                        onClick={() => setTabIndex(2)}
                        sx={{ cursor: 'pointer', fontSize: 14 }}
                    >
                        Ver más
                    </Typography>
                )}
                {urlVerMas && (
                    <Link href={urlVerMas} prefetch={false}>
                        <Typography sx={{ color: 'primary.main', cursor: 'pointer', fontSize: 14 }}>
                            Ver más
                        </Typography>
                    </Link>
                )}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 1,
                    px: 0,
                }}
            >
                <GetFixtureBox fixtures={fixtures} id={id} isLastFixtures={isLastFixtures} />
            </Box>
        </CustomSectionWrapper>
    );
};

export default FixturesPreview;
